module.exports = __webpack_public_path__ + "img/first_sleep--active.997a3515.svg";